import { AUTH_ORIGINS, regionalAccountHref } from "./account-links";

/** An explicit click submits a CSRF-protected form to the regional Auth Web. */
export function installTrialEntry(view: Window): void {
  let submitting = false;
  view.document.addEventListener("click", async event => {
    const anchor = event.target instanceof Element
      ? event.target.closest<HTMLAnchorElement>(".offer-trial a[data-verified-registration]") : null;
    if (!anchor || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (submitting || import.meta.env.VITE_BB_TRIAL_ENABLED !== "true") return;
    const href = regionalAccountHref(anchor.href, view.location.hostname, view.document.documentElement.lang);
    if (!href) return;
    const target = new URL(href);
    if (!Object.values(AUTH_ORIGINS).some(origin => origin === target.origin)) return;
    submitting = true;
    anchor.setAttribute("aria-busy", "true");
    const failure = new URL("/trial/unavailable", target.origin);
    failure.searchParams.set("lang", target.searchParams.get("lang") || "en");
    try {
      const contextUrl = new URL("/trial/context", target.origin);
      const response = await view.fetch(contextUrl, {
        credentials: "include", cache: "no-store", referrerPolicy: "no-referrer",
        signal: AbortSignal.timeout(8000),
      });
      if (!response.ok) throw new Error("trial-context-unavailable");
      const context = await response.json() as { available?: unknown; csrf?: unknown };
      if (context.available !== true) { failure.searchParams.set("reason", "closed"); throw new Error("trial-closed"); }
      if (typeof context.csrf !== "string" || !/^[A-Za-z0-9_-]{32,128}$/.test(context.csrf)) throw new Error("trial-context-invalid");
      const destination = new URL("/trial/start", target.origin);
      destination.searchParams.set("lang", target.searchParams.get("lang") || "en");
      const form = view.document.createElement("form");
      form.className='ym-hide-content ym-disable-submit';
      form.method = "POST"; form.action = destination.href; form.hidden = true;
      const csrf = view.document.createElement("input");
      csrf.className='ym-hide-content ym-disable-keys';
      csrf.type = "hidden"; csrf.name = "csrf"; csrf.value = context.csrf;
      form.append(csrf); view.document.body.append(form);
      view.dispatchEvent(new Event('bb:registration-start'));
      form.submit();
    } catch {
      view.location.assign(failure.href);
    } finally {
      submitting = false; anchor.removeAttribute("aria-busy");
    }
  }, true);
}
